module.exports = [{"code":5,"name":"蓝色"},{"code":6,"name":"黄色"},{"code":9,"name":"绿色"},{"code":99,"name":"未知"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/plateColor.json
// module id = Nn86
// module chunks = 11